const l = {
  name: "Germany",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2.7,0.3L1.3,1.7l1.5,1.5C1.2,3.7,0,5.2,0,7c0,9.4,7.6,17,17,17c1.8,0,3.3-1.2,3.8-2.8l1.5,1.5l1.4-1.4
			L22.4,20l1.3-1.3l-1.4-1.4l-1.5,1.5c-0.5-1.6-2-2.8-3.8-2.8c-5,0-9-4-9-9c0-1.8-1.2-3.3-2.8-3.8l1.5-1.5L5.3,0.3L4,1.6L2.7,0.3z
			 M4,5c1.1,0,2,0.9,2,2c0,1.3,0.2,2.6,0.7,3.8L4.9,11l0.2,2l2.5-0.3c0.3,0.5,0.6,0.9,1,1.3l-1.3,1.3l1.4,1.4l1.3-1.3
			c0.4,0.4,0.9,0.7,1.3,1L11,18.9l2,0.2l0.2-1.8c1.2,0.4,2.5,0.7,3.8,0.7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C8.7,22,2,15.3,2,7
			C2,5.9,2.9,5,4,5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Germany
};
